<section class="min-w-96">
    @if (advisorContact) {
        <div class="flex bg-neutral-200 rounded-lg py-5 px-7 justify-between">
            <div>
                <h2 class="text-tertiary-900 !text-base font-medium">
                    My Spectrum Advisor
                </h2>
                <p class="text-sm text-tertiary-900">
                    {{ advisorContact.displayName }}
                </p>
                <p class="text-sm text-tertiary-900">
                    {{ advisorContact.phone.phoneNumber }}
                </p>
                <p class="text-sm text-primary-700">
                    <a href="mailto:{{ advisorContact.email.emailAddress }}">{{
                        advisorContact.email.emailAddress
                    }}</a>
                </p>
            </div>
        </div>
    }
</section>
